import { Component, EventEmitter, Output, Input, OnDestroy } from '@angular/core';
import { ConfirmOutput } from '@app/cp/shared/models/ConfirmOutput';
import { CPDialogResult } from '@app/cp/shared/enums/CPDialogResult';
import { CRUDActions } from '@app/cp/shared/enums/CRUDActions';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';

import { GGItem } from '../../models/GGItem';
import { DispatchQVBus } from '../../models/DispatchQVBus';
import { DispatchForCheckBValid } from '../../models/DispatchForCheckValid';
import { CommonParam } from '../../models/CommonParam';
import { Subscription } from 'rxjs';

@Component({
    selector: 'dispatch-account-class-dialog',
    templateUrl: './dispatch-account-class-dialog.component.html',
    styleUrls: ['./dispatch-account-class-dialog.component.scss'],
    standalone: false
})
export class DispatchAccountClassDialogComponent  implements OnDestroy  {

    constructor(private globals: GlobalsService, private svc_data: DispatchesService) {
    }
    data: DispatchForCheckBValid;
    get hasData(): boolean {
        return CommonFunctions.hasValue(this.data);
    }
    get hasAccountClassId() : boolean {
        return CommonFunctions.hasGuidValue(this.accountClassId);
    }
    get accountClassId(): any {
        return this.hasData ? this.data.accountClassId : null;
    }
    set accountClassId(value: any) {
        if (this.hasData) {
            this.data.accountClassId = value;
        }
    }
    get hasPriorityId(): boolean {
        return CommonFunctions.hasGuidValue(this.priorityId);
    }
    get priorityId(): any {
        return this.hasData ? this.data.priorityId : null;
    }
    set priorityId(value: any) {
        if (this.hasData) {
            this.data.priorityId = value;
        }
    }
    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    ngOnDestroy() {
        CommonFunctions.unsubscribe(this.subs_data);
    }

    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    protected _param: CommonParam;
    showAccountClass: boolean = false;
    showPriority: boolean = false;
    @Input() set param(value: CommonParam) {
        if (value) {
            this._param = value;
            this._dispatchId = this._param.getParam("dispatchId");
            this.getData();
            this.active = true;
        }
    }
    active: boolean = false;
    code: string = "AccountClass";

    protected _dispatchId: any;
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    @Input() isConstruction: boolean;
    @Input() showAllClasses: Boolean = false;
    @Input() messageText: string = "Field(s) Required to Assign a Tech";
    @Output() closed: EventEmitter<ConfirmOutput> = new EventEmitter<ConfirmOutput>();
    action: CRUDActions;
    list: GGItem[] = []
    subs_data: Subscription;
    cboChanged(e: GGItem) {

    }
    getData() {
        this.subs_data = this.svc_data.getDispatchForCheckValid(this._dispatchId).subscribe((info: BaseMessageInfo) => {

            if (!info.saveError) {
                this.data = info.primaryReturn;

                let _code: string = null;
                if (!this.hasAccountClassId) {
                    _code = "AccountClass"
                    this.showAccountClass = true;
                }
                if (!this.hasPriorityId) {
                    if (_code !== null) {
                        _code = _code + ",Priority";
                    }
                    else {
                        _code = "Priority"
                    }
                    this.showPriority = true;
                }
                this.code = _code;

            }
        })
    }
    save() {
        let busObj: DispatchQVBus = new DispatchQVBus(null);
        busObj.saveCode = this.code;
        busObj.dispatchId = this._dispatchId;
        busObj.accountClassId = this.accountClassId;
        busObj.priorityId = this.priorityId;
        this.svc_data.saveDispatchItemsQV(busObj).subscribe((info: BaseMessageInfo) => {

            if (!info.saveError) {
                this.globals.notifySuccess(this.code + " Successfully Saved");
                let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.ok, data: this._param, code: this.code }
                this.closed.emit(result);
                this.hide();
            }
            else {
                this.globals.notifyError("Error Saving " + this.code + ": " + info.message);
            }
        });

    }
    ok() {
        this.save();
    }
    cancel() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.cancel, data: null, code: this.code }
        this.closed.emit(result);
        this.hide();
    }
    close() {
        let result: ConfirmOutput = { action: this.action, dialogResult: CPDialogResult.close, data: null, code: this.code }
        this.closed.emit(result);
        this.hide();
    }
    hide() {
        this.active = false;
        this.param = null;
    }
    public show(id: any) {

        this.active = true;

        this.list = [];

    }

}

